import { IEntity, ObjectState } from '../interfaces/entity';
import { DataField } from './data-field';
import {Template, TEMPLATE_TYPE} from './template';

export interface ISubjectTypeList{
  items: SubjectType[];
  totalCount: number;
}

export class SubjectType implements IEntity {
  id: number;
  uid: string;
  name: string;
  description: string;
  primary: boolean;
  allowReferral: boolean;
  disableSubjectMatching: boolean;
  hideRecord: boolean;
  dataFields: DataField[];
  color: string;
  canDelete: boolean;

  constructor(subjectType?)
    {
        subjectType = subjectType || {};
        this.id = subjectType.id;
        this.uid = subjectType.uid;
        this.name = subjectType.name || '';
        this.description = subjectType.description || '';
        this.primary = subjectType.primary || false;
        this.allowReferral = subjectType.allowReferral || false;
        this.disableSubjectMatching = subjectType.disableSubjectMatching || false;
        this.hideRecord = subjectType.hideRecord || false;
        this.canDelete = subjectType.canDelete;
        this.dataFields = subjectType.dataFields || [
          {
              id: 1,
              name: 'Reference',
              dataType: 'Text',
              min: 1,
              max: 50,
              label: 'Reference',
              required: false,
              default: '',
             fixed: true,
             objectState: ObjectState.Added,
          },
          {
            id: 2,
            name: 'Summary',
            dataType: 'Text',
            min: 1,
            max: 500,
            label: 'Summary',
            required: false,
            default: '',
            fixed: true,
            readOnly: true,
           objectState: ObjectState.Added,
          },
          {
              id: 3,
              name: 'CategoryId',
              dataType: 'Category',
              label: 'Category',
              required: false,
              default: '',
             fixed: true,
             objectState: ObjectState.Added,
          }, 
          {
            id: 4,
            name: 'Labels',
            dataType: 'Text',
            min: 1,
            max: 500,
            label: 'Labels',
            required: false,
            default: '',
           fixed: true,
           objectState: ObjectState.Added,
          },
          {
            id: 5,
            name: 'DateCreated',
            dataType: 'Date',
            label: 'Date Created',
            fixed: true,
            readOnly: true,
            objectState: ObjectState.Added,
          },
          {
            id: 6,
            name: 'CreatedById',
            dataType: 'User',
            label: 'Created By',
            fixed: true,
            readOnly: true,
            objectState: ObjectState.Added,
          },
          {
            id: 7,
            name: 'UserId',
            dataType: 'User',
            label: 'User',
            fixed: true,
            objectState: ObjectState.Added,
          },
          {
            id: 8,
            name: 'ManagerId',
            dataType: 'User',
            label: 'Manager',
            fixed: true,
            objectState: ObjectState.Added,
          },
          {
            id: 9,
            name: 'PrimaryLink',
            dataType: 'Text',
            min: 1,
            max: 500,
            label: 'Primary Link(s)',
            required: false,
            readOnly: true,
            fixed: true,
            objectState: ObjectState.Added,
          },
          {
            id: 10,
            name: 'Markers',
            dataType: 'Markers',
            label: 'Markers',
            required: false,
            readOnly: true,
            fixed: true,
            objectState: ObjectState.Added,
          },
      ],
      this.color = subjectType.color || '#0277bd';
    }

  getDataField(name: string): DataField {
    return this.dataFields.find((item) => item.name.toLowerCase() === name.toLowerCase());
  }

  getFieldId(name: string): number{
    const dataField = this.getDataField(name);
    return (dataField) ? dataField.id : -1;
  }
}
